import { atomWithReset } from 'jotai/utils';

import { ChargeModal } from './types';

export const chargeModalState = atomWithReset<ChargeModal>({
  isOpen: false,
  appointmentId: null,
});
